import { event } from "dashboard-utils/lib/utils/clevertap";
import {
    isAndroidApp,
    isIOSApp,
  } from "dashboard-utils"

const pageNames = {
    'business': 'Business Summary',
    'transactions': 'Transactions',
    'settlements': 'Settlements',
    'reports': 'Reports',
    'payment-links': 'Payment tools',
    'buttons': 'Payment tools',
    'invoices': 'Payment tools',
    'settings': 'Settings',
    'front-office': 'Launchpad',
    'aggregator': 'Split Settlement Page',
    'payment-gateway': 'Payment Gateway'
}

const getPlatform = () => {
    let platform;
    if(isAndroidApp) platform = 'App Android';
    if(isIOSApp) platform ='App iOS';
    return platform;
}

export const CTAPage = (path) => {
    let paths = path.split('/');
    if(pageNames[paths[paths.length-1]]) {
        return pageNames[paths[paths.length-1]]
    }else{
        return paths[paths.length-1];
    }
}

export const sendCTEvent = ({ isInitialLoad }) => {
    let page = CTAPage(window?.location?.pathname);
    let platform = getPlatform()
    let eventData = {
        "CTA Name": isInitialLoad ? 'Dashboard Login Successful' : page,
        "CTA Page": page,
        "CTA type": "View",
      }
    if(platform) eventData["Platform"] = platform;
    event("Dashboard CTA clicked", eventData);
}